import { z } from "zod";

export type RequestPasswordResetFormValues = {
  email: string;
};

export const initialRequestPasswordResetFormValues: RequestPasswordResetFormValues =
  {
    email: "",
  };

export const requestPasswordResetSchema = z.object({
  email: z.preprocess(
    (value) => (typeof value === "string" ? value.trim() : value),
    z.email("Bitte geben Sie eine gültige E-Mail-Adresse ein."),
  ),
});

export type ResetPasswordFormValues = {
  password: string;
  confirmPassword: string;
};

export const initialResetPasswordFormValues: ResetPasswordFormValues = {
  password: "",
  confirmPassword: "",
};

export const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .min(12, "Das Passwort muss mindestens 12 Zeichen enthalten.")
      .max(256, "Das Passwort ist zu lang."),
    confirmPassword: z
      .string()
      .min(1, "Bitte bestätigen Sie Ihr Passwort."),
  })
  .superRefine((values, ctx) => {
    if (values.password !== values.confirmPassword) {
      ctx.addIssue({
        code: "custom",
        path: ["confirmPassword"],
        message: "Die Passwörter stimmen nicht überein.",
      });
    }
  });
